import { render, staticRenderFns } from "./ProvidingServices.vue?vue&type=template&id=06438478&scoped=true&"
import script from "./ProvidingServices.vue?vue&type=script&lang=js&"
export * from "./ProvidingServices.vue?vue&type=script&lang=js&"
import style0 from "./ProvidingServices.vue?vue&type=style&index=0&id=06438478&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06438478",
  null
  
)

export default component.exports